module.exports = __webpack_public_path__ + "img/recoloredSuburbs.cd51c6f4.png";